<template>
	<!--  ViewClassroomBoardList.vue: 강의실 > 게시판 > 게시물목록 화면 (notice.html) -->
	<fragment v-if="lecture">
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section  ref="container" class="container">
			<common-side-menu :menus="side_menus" :btnList="side_buttons"></common-side-menu>

			<div class="container-fiuld class-making-box clearfix">
				<template  v-if="parentsArticle">
					<div class="title-box m-b-30 b-b clearfix">
						<div class="f-18 pull-left text-blue p-10">
							{{side_menus.length ? side_menus.find(e=>e.selected).name : ''}}
						</div>
					</div>
					<div class="white-box m-t-10 clearfix">
						<p class="f-18 m-b-15 m-t-10 text-bold text-blue">{{parentsArticle.title}}</p>
						<div class="input-group full-width">
							<span class="input-group-addon text-left">
								<b>분류 :</b> {{parentsArticle.articleCategoryNm}}
							</span>
							<span class="input-group-addon w100 text-left">
								<b>작성자 :</b> {{parentsArticle.mberId}}
							</span>
							<span class="input-group-addon w160 text-left">
								<b>작성일 :</b> {{parentsArticle.regDate}}
							</span>
							<span class="input-group-addon w60 text-left">
								<b>조회 :</b> {{ parentsArticle.lookupCount }}
							</span>
						</div>
						<div class="on-border round p-15 m-t-5 m-b-10" v-html="parentsArticle.content"></div>
						<ul class="m-b-10" v-if="parentsArticle.articleFileMappingList.length > 0">
							<li v-for="file in parentsArticle.articleFileMappingList" :key="`article-file-${hash(file)}`">
								<a class="down-btn" :href="'/download/'+file.atchFileId" target="_blank">{{file.orignlFileNm}}</a>
							</li>
						</ul>
					</div>
					<div class="white-box m-t-10 clearfix">
						<div class="comment" v-for="comment in parentsArticle.commentList" :key="`comment-${hash(comment)}`">
							<p class="m-b-0 clearfix">
								{{comment.mberId}} ｜ {{comment.regDate}}
								<span class="pull-right">
									<a class="modify"></a>
									<a class="del"></a>
								</span>
							</p>
							<div class="bg-lightgray p-15" style="line-height: 1.4;" v-html="comment.content ? comment.content.replace(/\n/g, '<br>') : ''"></div>
						</div>
					</div>
				</template>

				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10" v-if="side_menus.length">
						{{parentsArticle ? "답글쓰기" : (side_menus.length ? side_menus.find(e=>e.selected).name : '')}}
					</div>
				</div>
				<div class="input-group full-width">
					<span class="input-group-addon w160 p-r-5">
						<select class="form-control round m-b-0" v-model="articleCategoryId" v-if="side_menus.length">
							<option value="0">분류 선택 안함</option>
							<option v-for="category in side_menus.find(e=>e.selected).board.articleCategoryList"
								:key="`option-category-${hash(category)}`" :value="category.articleCategoryId">
								{{category.name}}
							</option>
						</select>
					</span>
					<span class="input-group-addon">
						<input class="form-control round m-b-0" type="text" placeholder="제목을 입력하세요." v-model="title">
					</span>
				</div>
				<div class="input-group full-width m-t-10">

					<span class="input-group-addon bg-white on-border round v-mid text-left p-5">
						<span class="text-darkgray" v-for="(fileName, idx) in articleFileNames" :key="`article-file-${fileName}`">
							{{fileName}}<a @click="articleFileMappingList.splice(idx, 1); articleFileNames.splice(idx, 1)" class="f-16 m-l-5 m-r-10 text-blue text-bold">×</a>
						</span>
					</span>
					<span class="input-group-addon w40 v-mid p-l-5">
						<input id="file" type="file" style="display: none;" ref="fileRef" @change="fileUpload">
						<label for="file" class="btn btn-darkgray f-14 round full-width">+</label>
					</span>
				</div>
				<div class="input-group full-width m-t-10 bg-white">
					<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
				</div>
				<button class="btn btn-blue round m-t-30 m-b-30 pull-right" type="button" @click="putArticle">완료하기</button>
				<button class="btn btn-red round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="$router.push('/classroom/'+$route.params.lecId+'/board/'+$route.params.boardId)">취소</button>
			</div>
		</section>
		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import Axios from 'axios'
import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomBoardRegister',
	mixins: [
		fnAdjustHeight,
		fnGetLec
	],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert,
	},
	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.side_menus = await this.getBoardSideMenus(lecId);
		this.getParentsArticle();

		let that = this;
		window.tinymce.init({
			selector: '.editorContent',
			height: 500,
			branding: false,
				plugins: [
					"autoresize",
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste imagetools wordcount lineheight addfile"
				],
				content_style: "body {margin: 40px 2rem !important; line-height: 1.5; width:866px;} body > p {margin: 0}",
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image addfile",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
				images_upload_handler: function(blobInfo, success) {
					const formData = new FormData();
					formData.append('file', blobInfo.blob(), blobInfo.filename());
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				files_upload_handler: function(fileObj, success) {
					const formData = new FormData();
					formData.append('file', fileObj);
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
			setup: function(editor) {
				editor.on('init', function() {
					editor.setContent(that.content);
				});
				editor.on("change", function() {
					that.content = editor.getContent();
				})
			}
		}).then((r) => {this.editorContent = r[0]});
	},
	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			lecture: null,
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:true},
			],
			side_menus: [],
			side_buttons : [],
			buttons : [
				{name:'작성완료', fn: () => {}}
			],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},

			parentsArticle: null,

			parentsId: this.$route.params.parentsId ? parseInt(this.$route.params.parentsId) : 0 ,
			articleCategoryId: 0,
			articleFileNames: [],
			articleFileMappingList: [],
			title: "",
			content: "",
			editorContent: null
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		getParentsArticle: async function() {
			if(!this.parentsId) return;
			try {
				const {data} = await Axios.post(`${server.addr()}${server.api.ARTICLE}/${this.parentsId}`, {})
				this.parentsArticle = data.return;
			} catch(e) { e }
		},
		fileUpload: async function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRef.files[0]);

			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.FILE}`, formData);

				this.articleFileNames.push(this.$refs.fileRef.files[0].name);
				this.articleFileMappingList.push({atchFileId:data});
			} catch(e) {
				//TODO: error exception
			}
		},
		putArticle: async function() {
			const { articleCategoryId, articleFileMappingList, title, content, parentsId } = this;
			const { boardId, lecId } = this.$route.params;
			try {
				await Axios.put(`${server.addr()}${server.api.ARTICLE}`, [{
					articleCategoryId, articleFileMappingList, title, content, parentsId, boardId
				}]);
				this.$router.push(`/classroom/${lecId}/board/${boardId}`);
			} catch(e) {
				// TODO: error exception
			}
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>
